module.exports = __webpack_public_path__ + "img/role-50.d85ef2df.svg";